<template>
  <section class="cancel-order">
    <div class="cancel-content page-content">
      <header class="title">
        退款金额 <strong color-primary>{{currentOrder.need_pay}}</strong>
      </header>
      <p class="tip">预计3个工作日内原路退回到你的支付账户</p>
      <header class="title">取消原因</header>
      <ul class="reason-list">
        <li v-for="(item, index) in reasonList" :key="index">
          <span class="reason-text">{{item.label}}</span>
          <i class="iconfont" :class="item.checked?'etc-icon-check':'etc-icon-circle-uncheck'" @click="checkReason(index)"></i>
        </li>
      </ul>
      <div class="else-reason">
        <p class="title">其他</p>
        <textarea placeholder="请输入" v-model="elseReason" maxlength="60"></textarea>
        <span class="else-reason-length">{{elseReason.length}}/60</span>
      </div>
    </div>
    <div class="cancel-bottom">
      <button cool-btn-hollow @click="cancelOrder">取消申办</button>
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// store
import {mapMutations, mapState} from 'vuex'
// api
// import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'

// config
// import ETC from '@/config/etc.config'

let customData = {
  checkReasonVal: ''
}

export default {
  name: 'cancelOrder',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      reasonList: [
        {
          label: '选错卡',
          value: '',
          checked: false,
          reasonId: 41
        }, {
          label: '地址信息填写错误',
          value: '',
          checked: false,
          reasonId: 42
        }, {
          label: '身份证不在身边',
          value: '',
          checked: false,
          reasonId: 43
        }, {
          label: '行驶证不在身边',
          value: '',
          checked: false,
          reasonId: 44
        }, {
          label: '不想申办了',
          value: '',
          checked: false,
          reasonId: 45
        }
      ],
      elseReason: ''
    }
  },
  computed: {
    ...mapState([
      'currentOrder'
    ])
  },
  methods: {
    checkReason(index) {
      this.reasonList.forEach((v, i) => {
        v.checked = i === index
        if (i === index) customData.checkReasonVal = v.label
      })
    },
    async cancelOrder() {
      await this.m_clickDebounce('cancelOrder')
      let reason = ''
      if (customData.checkReasonVal && this.elseReason) {
        reason = customData.checkReasonVal + '|' + this.elseReason
      } else {
        reason = customData.checkReasonVal + this.elseReason
      }
      this.m_showLoading()
      try {
        const orderSn = this.currentOrder.order_sn
        const res = await reconApply.applyCancelOrder({order_sn: orderSn || '', reason: reason})
        if (res.is_complet === 0) {
          setTimeout(() => {
            reconApply.orderGetCancelOrder({
              order_sn: orderSn,
              cancel_sn: res.cancel_sn
            })
              .then(res => {
                if (res.cancel_status === 6) {
                  reconApply.cancelStatusConfirm({
                    order_sn: orderSn
                  })
                    .then(() => {
                      this.setUserApplyStep(0)
                      this.setCurrentOrder({})
                      this.m_loadingClose()
                      this.m_showToast({msg: '已取消', icon: 'etc-icon-check success'})
                      this.m_backHome()
                    })
                } else {
                  this.m_showToast({msg: +res.cancel_status === 8 ? '订单取消失败，当前服务器繁忙' : '订单取消处理中，请1小时后进入小程序查看取消结果', icon: 'etc-icon-check success'})
                }
              })
          }, 5000)
        } else {
          this.setUserApplyStep(0)
          this.setCurrentOrder({})
          this.m_loadingClose()
          this.m_showToast({msg: '已取消', icon: 'etc-icon-check success'})
          await this.m_awaitTime(2000)
        }
        this.m_backHome()
      } catch (e) {
        this.m_loadingClose()
      }
    },
    ...mapMutations([
      'setCurrentOrder',
      'setUserApplyStep'
    ])
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.cancel-order{
  background-color: $page-bg-c;
  @include routeViewMinH(182px);
  header.title{
    padding: 40px 40px 20px;
    font-size: 26px;
    color: #999999;
  }
  .tip{
    background-color: #fff;
    padding-left: 40px;
    color: #333;
    font-size: 30px;
    line-height: 100px;

  }
  .reason-list{
    background-color: #fff;
    padding: 0 40px;
    li{
      padding: 20px 0;
      height: 100px;
      border-bottom: 1px solid $border-bottom-color;
      @extend %flex-space-between;
      .reason-text {
        font-size: 30px;
      }
      .iconfont {
        font-size: 50px;
      }
      .etc-icon-check {
        color: $primary-color;
      }
      .etc-icon-circle-uncheck {
        color: #eeeeee;
      }
    }
  }
  .else-reason {
    background-color: #fff;
    padding: 0 40px 10px;
    position: relative;
    .title {
      font-size: 34px;
      padding: 20px 0;
    }
    textarea {
      width: 100%;
      height: 200px;
      border: none;
    }
    .else-reason-length {
      position: absolute;
      right: 40px;
      bottom: 20px;
      font-size: 30px;
      color: #b5b5b5;
    }
  }
  .cancel-bottom {
    padding: 20px 40px 40px;
  }
}
</style>
